import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=3f48f890&scoped=true"
import script from "./DataList.vue?vue&type=script&lang=js"
export * from "./DataList.vue?vue&type=script&lang=js"
import style0 from "./DataList.vue?vue&type=style&index=0&id=3f48f890&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_cache-loader@4.1.0_webpack@4.47.0__css-load_edeb7b7ea9fcdff8c5beb98344f810d8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f48f890",
  null
  
)

export default component.exports